<template>
    <div id="app">
        <!--        <div id="nav">-->
        <!--            <router-link to="/">Home</router-link>-->
        <!--            |-->
        <!--            <router-link to="/about">About</router-link>-->
        <!--        </div>-->
        <div class="topimage-wrapper" style="background-color: black;color: white;text-align: left;">
            <img v-if="topImageURL" class="top-image" :src="topImageURL" alt="">
            <b-container fluid class="h-100">
                <b-row class="h-100">
                    <b-col cols="12" offset="0" offset-sm="3" sm="9" class="h-100">
                        <div class="h-100" style="padding-top: 2em; padding-bottom: 3em;">


                            <div v-if="actualLinks.length>0">Actual</div>

                            <ul class="h-100" v-if="this.actualLinks">
                                <div class="d-flex h-100 flex-column flex-wrap align-content-start">
                                    <li class="ml-3 ml-sm-5 text-white" v-for="link in actualLinks">

                                        <a class="text-white" :href="link.url" target="_blank">{{link.title}}</a>
                                    </li>

                                </div>
                            </ul>
                        </div>

                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div id="appcontent">
            <b-container fluid>
                <!--                TODO set up padding. needs to be a thinner website-->
                <b-row>
                    <b-col cols="2" sm="4">
                        <b-row class="searchbar-sidebar-wrapper">
                            <b-col cols="12" sm="9" md="8" class="d-none d-sm-flex">
                                <SearchBar></SearchBar>
                            </b-col>
                            <b-col cols="12" sm="3" md="4" class="mt-3 mt-sm-0">
                                <Sidebar></Sidebar>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="10" sm="8">
                        <b-row>
                            <b-col cols="12" class="d-flex d-sm-none">
                                <SearchBar class="mb-3"></SearchBar>

                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col cols="12">

                                <router-view/>
                            </b-col>

                        </b-row>
                    </b-col>
                    <!--                    <b-col cols="3">-->
                    <!--                       -->
                    <!--                    </b-col>-->

                </b-row>
            </b-container>

        </div>

    </div>
</template>


<script>
    // @ is an alias to /src

    import Sidebar from "./components/Sidebar";
    import SearchBar from "./components/SearchBar";


    export default {
        name: 'Approot',
        components: {
            SearchBar,
            Sidebar
        },
        computed: {
            topImageURL: function () {
                if (this.$store.state.homeContent && this.$store.state.topimage) {
                    return process.env.VUE_APP_API_URL + this.$store.state.homeContent.topimage.url

                } else {
                    return null
                }
            },
            actualLinks: function () {
                return this.$store.state.actualLinks
            }
        },
        mounted() {
            this.$store.dispatch("GET_WORKS_FROM_API")
            this.$store.dispatch("GET_HOMECONTENT_FROM_API")
            this.$store.dispatch("GET_ACTUALLINKS_FROM_API")

        }
    }
</script>


<style lang="scss">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        /*color: #2c3e50;*/
        font-size: 12px;

    }

    #appcontent {
        padding-top: 2em;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    .top-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: left;
    }

    .searchbar-sidebar-wrapper {
        top: 1em;
        position: sticky;
    }
</style>
